import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';

@Component({
    selector: 'lib-list-view',
    templateUrl: './list-view.component.html',
    styleUrls: ['./list-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class ListViewComponent<TItem = unknown, THeader = unknown, TFooter = unknown> {
    @Input()
    source?: TItem[];

    @Input()
    itemTemplate?: TemplateRef<{ $implicit: { object: TItem } }>;

    @Input()
    valueProperty?: keyof TItem;

    @Input()
    headerTemplate?: TemplateRef<THeader>;

    @Input()
    footerTemplate?: TemplateRef<TFooter>;

    @Input()
    selectedItem?: TItem;

    @Input()
    listViewId?: string;

    @Output()
    selectedItemChange: EventEmitter<TItem>;

    constructor() {
        this.selectedItemChange = new EventEmitter<TItem>();
    }

    onItemClicked(item: TItem): void {
        this.selectedItem = item;
        this.selectedItemChange.emit(item);
    }
}
